export default "__VITE_ASSET__CkQuzo_G__"